import Model, { attr } from '@ember-data/model'
import { Type } from '@warp-drive/core-types/symbols'
import { SubscriptionType } from 'district-ui-client/domain/subscription-type'
import type NumberTransform from 'district-ui-client/transforms/number'

/**
 * Model class for blake school statistics (gravity data)
 */
export default class SchoolStatistic extends Model {
  @attr<NumberTransform>('number') declare readingTeacherCount: number

  @attr<NumberTransform>('number') declare mathsTeacherCount: number

  @attr<NumberTransform>('number') declare readingStudentCount: number

  @attr<NumberTransform>('number') declare mathsStudentCount: number

  @attr<NumberTransform>('number') declare mathleticsStudentCount?: number

  @attr<NumberTransform>('number') declare mathleticsTeacherCount?: number

  @attr<NumberTransform>('number') declare writingStudentCount?: number

  @attr<NumberTransform>('number') declare writingTeacherCount?: number

  teacherCountFor(subscriptionType: SubscriptionType): number {
    switch (subscriptionType) {
      case SubscriptionType.Reading:
        return this.readingTeacherCount

      case SubscriptionType.Maths:
        return this.mathsTeacherCount
      case SubscriptionType.Mathletics:
        return this.mathleticsTeacherCount ?? 0
      case SubscriptionType.Writing:
        return this.writingTeacherCount ?? 0
      default:
        return 0
    }
  }

  studentCountFor(subscriptionType: SubscriptionType): number {
    switch (subscriptionType) {
      case SubscriptionType.Reading:
        return this.readingStudentCount
      case SubscriptionType.Maths:
        return this.mathsStudentCount
      case SubscriptionType.Mathletics:
        return this.mathleticsStudentCount ?? 0
      case SubscriptionType.Writing:
        return this.writingStudentCount ?? 0
      default:
        return 0
    }
  }

  get totalTeacherCount(): number {
    return (
      this.readingTeacherCount +
      this.mathsTeacherCount +
      (this.mathleticsTeacherCount ?? 0) +
      (this.writingTeacherCount ?? 0)
    )
  }

  get totalStudentCount(): number {
    return (
      this.readingStudentCount +
      this.mathsStudentCount +
      (this.mathleticsStudentCount ?? 0) +
      (this.writingStudentCount ?? 0)
    )
  }

  get studentCounts() {
    return {
      reading: this.readingStudentCount,
      maths: this.mathsStudentCount,
      mathletics: this.mathleticsStudentCount ?? 0,
      writing: this.writingStudentCount ?? 0,
    }
  }

  [Type] = 'school-statistic' as const
}
